import React from "react";
import { Container } from "react-grid-system";
import styled from "styled-components";
import Colors from "../../shared/colors";
import { Section } from "../../shared/shared";
import Background_1x from "../../images/network/background-rede-candidatar.png";
import Banner_1x from "../../images/network/img-rede-requisitos.png";
import Title from "../../components/title/title.component";
import { Link } from "react-router-dom";
import { lighten } from "polished";

export default class Requirements extends React.PureComponent {
  render() {
    let { t } = this.props;
    const i18n = this.props.i18n;
    // TO DO
    return (
      <span>
        <Banner>
          <img src={Banner_1x} alt="" />
        </Banner>
        <BackgroundRequirements
          style={{ backgroundImage: "url(" + Background_1x + ")" }}
        >
          <Container>
            <RequirementsBox>
              <BoxTitle>{t("RequirementsTitle")}</BoxTitle>
              <BoxSubText>{t("RequirementsDescription")}</BoxSubText>
              <BoxContent>
                <BoxCol>
                  <ul>
                    <li>{t("RequirementsTopic1")}</li>
                    <li>{t("RequirementsTopic2")}</li>
                    <li>{t("RequirementsTopic3")}</li>
                    <li>{t("RequirementsTopic4")}</li>
                    <li>{t("RequirementsTopic5")}</li>
                  </ul>
                </BoxCol>
                <BoxCol>
                  <ul>
                    <li>{t("RequirementsTopic6")}</li>
                    <li>{t("RequirementsTopic7")}</li>
                    <li>{t("RequirementsTopic8")}</li>
                    <li>{t("RequirementsTopic9")}</li>
                    <li>{t("RequirementsTopic10")}</li>
                  </ul>
                </BoxCol>
              </BoxContent>
              <TextBottom>
                <p>{t("RequirementsLegend")}</p>
                <ul>
                  <li>{t("RequirementsTopic11")}</li>
                  <li>{t("RequirementsTopic12")}</li>
                  <li>{t("RequirementsTopic13")}</li>
                </ul>
              </TextBottom>
            </RequirementsBox>
          </Container>
          <Section>
            <Container>
              <Title text={t("HowToApply")} />
              <TextRequirement>{t("ApplyText")}</TextRequirement>

              {i18n.language === "pt" && (
                <Link to="/pt/rede/candidatura">
                  <LinkButton>CANDIDATAR</LinkButton>
                </Link>
              )}
              {i18n.language === "en" && (
                <Link to="/en/network/apply">
                  <LinkButton>APPLY</LinkButton>
                </Link>
              )}
              {i18n.language === "de" && (
                <Link to="/de/netzwerk/anwendung">
                  <LinkButton>ANWENDUNG</LinkButton>
                </Link>
              )}
            </Container>
          </Section>
        </BackgroundRequirements>
      </span>
    );
  }
}

const Banner = styled.div`
  img {
    width: 100%;
    height: 480px;
    object-fit: cover;
  }
`;
const BackgroundRequirements = styled.div`
  width: 100%;
  background-size: cover;
  background-position: fixed;
  background-position: center;
`;
const RequirementsBox = styled.div`
  width: 887px;
  min-height: 500px;
  background-color: #ffffff;
  box-shadow: 0 0 10px 3px rgba(0, 0, 0, 0.1);
  margin-left: auto;
  margin-right: auto;
  margin-top: -300px;
  position: relative;
  padding: 20px 40px;

  @media screen and (max-width: 1200px) {
    width: calc(100% - 80px);
  }
`;

const BoxTitle = styled.h2`
  text-align: center;
  color: hsl(0, 0%, 17%);
  font-family: "PT Sans";
  font-size: 30px;
  text-transform: uppercase;
  margin-bottom: 15px;
`;

const BoxSubText = styled.h5`
  max-width: 650px;
  opacity: 0.8;
  color: hsl(0, 0%, 17%);
  font-family: "PT Sans";
  font-size: 16px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
  margin-bottom: 0px;
  font-weight: normal;
`;

const BoxContent = styled.div`
  display: flex;
  justify-content: space-between;

  @media screen and (max-width: 767px) {
    display: block;
  }
`;

const BoxCol = styled.div`
  width: 45%;

  ul {
    li {
      color: hsl(0, 0%, 17%);
      font-family: "PT Sans";
      font-size: 18px;
      padding-top: 15px;
    }
  }

  @media screen and (max-width: 767px) {
    width: 100%;
  }
`;

const TextBottom = styled.div`
  p {
    opacity: 0.8;
    color: hsl(0, 0%, 17%);
    font-family: "PT Sans";
    font-size: 16px;
    line-height: 22px;
  }

  ul {
    li {
      color: hsl(0, 0%, 17%);
      font-family: "PT Sans";
      padding-bottom: 15px;
      font-size: 18px;
    }
  }
`;

const TextRequirement = styled.div`
  max-width: 770px;
  opacity: 0.8;
  color: hsl(0, 0%, 17%);
  font-family: "PT Sans";
  font-size: 16px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  line-height: 25px;
  margin-top: 30px;
`;

const LinkButton = styled.div`
  width: 170px;
  background-color: ${Colors.primary};
  color: ${Colors.white};
  border-radius: 3px;
  padding: 15px 20px;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.3s ease;
  font-family: "PT Sans";
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  margin-top: 50px;
  margin-bottom: 40px;

  &:hover {
    background: ${lighten(0.05, Colors.primary)};
  }
`;



// WEBPACK FOOTER //
// ./src/components/requirements/requirements.component.js